import dayjs from 'dayjs'

import { dataLayer } from '../adobeAnalytics/adobeAnalytics.conf'
import gc_de from './CargoCompactOnline_GeneralCondition_de.pdf'
import gc_fr from './CargoCompactOnline_GeneralCondition_fr.pdf'
import gc_it from './CargoCompactOnline_GeneralCondition_it.pdf'

export const mountDownablePDF = (
  pdfFile: any,
  offerNumber: number,
  isPolicy?: boolean,
) => {
  var link = document.createElement('a')
  link.href = window.URL.createObjectURL(pdfFile)
  link.target = '_blank'
  link.download = `CLO_${isPolicy ? 'Policy' : 'Offer'}_${offerNumber}_${dayjs(
    new Date(),
  ).format('YYYY-MM-DD')}.pdf`
  document.body.appendChild(link)
  link.click()

  dataLayer.event.eventInfo.fileDownload = link.download
}

export const generalConditions = {
  de: gc_de,
  fr: gc_fr,
  it: gc_it,
}
